import { useTranslation } from "react-i18next";

export default function WanneerVervangen() {
  const { t } = useTranslation("slot-cilinder-vervangen");
  const rows = t("wanneer.rows", { returnObjects: true }) as Array<{
    title: string;
    desc: string;
  }>;

  const images = [
    "/img/26-damaged-door-lock-cylinder.jpg",
    "/img/33-hands-holding-lost-house.jpg",
    "/img/31-stiff-door-lock-mechanism.jpg",
    "/img/06-aerial-cardboard-moving-boxes.jpg",
    "/img/28-high-security-skg-three.jpg",
    "/img/30-patio-sliding-door-lock.jpg",
  ];

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("wanneer.h2")}
        </h2>

        <div className="flex flex-col gap-12 md:gap-16">
          {rows.map((row, i) => (
            <div
              key={i}
              className={`flex flex-col ${i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"} items-stretch gap-6 md:gap-10`}
            >
              <div className="flex-1 relative min-h-[260px] md:min-h-0 rounded-xl overflow-hidden">
                <img
                  src={images[i]}
                  alt={`${row.title} - slotvervanging situatie in Eindhoven`}
                  className="absolute inset-0 w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 flex flex-col justify-center">
                <h3 className="font-geist font-bold text-xl md:text-2xl text-brand-text mb-3 md:mb-4">
                  {row.title}
                </h3>
                <p className="font-geist text-sm md:text-base text-brand-text/70 leading-relaxed">
                  {row.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}